import { z } from 'zod';
/**
 * Brief kind — drives the render template + dispatch policy. Includes
 * a `'no-brief-today'` sentinel per #166 Phase 1 §06 Q4 (explicit empty
 * state instead of auto-jumping to yesterday).
 */
export const BriefKind = z.enum([
    'daily', // Monday-Friday morning briefing
    'weekly', // Sunday evening retro
    'ad-hoc', // Manually-triggered (e.g. board prep)
    'meeting-prep', // Pre-meeting brief
    'catch-up', // After being away
    'no-brief-today', // Empty surface — agent had nothing material to brief
]);
